import React, { ChangeEvent } from "react";

interface TextareaProps {
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
  placeholder?: string;
}

const Textarea: React.FC<TextareaProps> = ({
  value,
  onChange,
  rows = 8,
  className = "",
  disabled = false,
  readOnly = false,
  placeholder = "",
}) => {
  return (
    <textarea
      value={value}
      onChange={onChange}
      rows={rows}
      readOnly={readOnly}
      placeholder={placeholder}
      disabled={disabled}
      className={`placeholder:text-black/10 dark:placeholder:dark:text-white/10   resize-none bg-transparent w-full text-xs !p-1 font-mono  border dark:border-primary-dark border-primary  file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    ></textarea>
  );
};

export default Textarea;
